import React from 'react';
import { Paper, Typography, Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';
const Mentionslegales = () => {
    const theme = useTheme();
    return (
        <Container maxWidth="lg" style={{ marginTop: '20px', marginBottom: '40px' }}>
            <Paper elevation={3} style={{ padding: '20px',
                Color: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light
            }}>
                <Typography variant="h4" gutterBottom>
                    LES MENTIONS LÉGALES MONUNIP.FR
                </Typography>
                <Typography variant="body1" paragraph>
                    Éditeur du site :
                </Typography>
                <Typography variant="body1" paragraph>
                    Le site monunip.fr a été édité par :
                </Typography>
                <Typography variant="body1" paragraph>
                    UNIPREVOYANCE
                    <br />
                    38-42 Rue Cuvier
                    <br />
                    CS 80 002
                    <br />
                    93102 Montreuil Cedex
                </Typography>
                <Typography variant="body1" paragraph>
                    Institution Paritaire de Prévoyance régie par le Code de la Sécurité Sociale.
                    <br />
                    Siret : 318 990 736 00049
                    <br />
                    Tel : 01 58 64 41 00
                    <br />
                    Fax : 01 58 64 42 30
                </Typography>
                <Typography variant="body1" paragraph>
                    Responsable de rédaction :
                </Typography>
                <Typography variant="body1" paragraph>
                    Philippe MAISONNAVE
                </Typography>
                <Typography variant="body1" paragraph>
                    Uniprévoyance relève de l’Autorité de Contrôle Prudentiel et de Résolution (ACPR)
                    <br />
                    61 rue Taitbout, 75436 Paris Cedex 9
                </Typography>
                <Typography variant="body1" paragraph>
                    Identifiant unique REP :
                    <br />
                    N° IDU (Identifiant Unique pour la filière PAPIERS – éco-organisme CITEO) : FR 313045-03IPGA
                </Typography>
                <Typography variant="body1" paragraph>
                    Hébergeur :
                </Typography>
                <Typography variant="body1" paragraph>
                    AMAZON WEB SERVICES EMEA SARL
                    <br />
                    31 Place des corolles,
                    <br />
                    Tour Carpe Diem
                    <br />
                    92400 Courbevoie
                    <br />
                    FRANCE
                </Typography>
            </Paper>
        </Container>
    );
};

export default Mentionslegales;